// Razor kit + 24-pack blades pairing: the kit and blades added together by the "add blades" frequency
// option (frequency-selector.js) share a token in `_razor_kit_razor` / `_razor_kit_blades` and can't be
// bought without each other. Whenever the cart changes, remove any half of a pair whose partner is gone.
// Replaces src/scripts/theme/razer-kit-checker.js, deleted with the Vue bundle in e55d1c09.
(function () {
  var removing = false;

  function findOrphanKeys(cart) {
    var items = (cart && cart.items) || [];
    var razorTokens = {};
    var bladesTokens = {};
    items.forEach(function (line) {
      var props = line.properties || {};
      if (props._razor_kit_razor) razorTokens[props._razor_kit_razor] = true;
      if (props._razor_kit_blades) bladesTokens[props._razor_kit_blades] = true;
    });

    var keys = [];
    items.forEach(function (line) {
      var props = line.properties || {};
      if (props._razor_kit_razor && !bladesTokens[props._razor_kit_razor]) keys.push(line.key);
      else if (props._razor_kit_blades && !razorTokens[props._razor_kit_blades]) keys.push(line.key);
    });
    return keys;
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    if (removing) return;
    var keys = findOrphanKeys(event.detail && event.detail.cart);
    if (!keys.length) return;

    removing = true;
    // Keyed by line key, not variant id, so other lines of the same variant are left untouched.
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        removing = false;
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function (err) {
        removing = false;
        console.error('[razorKitPairing] Failed to remove unpaired razor kit line:', err);
      });
  });
})();
